import { defineComponent as _defineComponent } from 'vue';
import ObjectPermissions from "./ObjectPermissions.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectPermissionsModal',
    props: {
        markdownContent: null
    },
    setup(__props) {
        return { __sfc: true, ObjectPermissions };
    }
});
